import { useRef, useEffect, useCallback } from "react";
import "./sprites.css";

const WalkingSprite = ({ errorMsg,name, slides, delay }) => {
  const sprite = useRef("");
  const i = useRef(1);
  const start = useRef(undefined);
  const main = "main";

  const noop = () => {};

  const animate = useCallback(
    (timestamp) => {
      if (start.current === undefined) {
        start.current = timestamp;
      }
      const elapsed = timestamp - start.current;

      if (elapsed > delay && sprite.current) {
        sprite.current.classList.remove(name + (i.current - 1));
        if (i.current > slides) i.current = 1;
        sprite.current.classList.add(name + i.current++);
        start.current = timestamp;
        // console.log("sprite");
      } else {
        // console.log("noop");
        noop();
      }
      requestAnimationFrame(animate);
    },
    [delay, slides, name]
  );

  useEffect(() => {
    animate(2000);
  }, [animate]);

  return (
    <>
      <div className={main}>
        <div ref={sprite} className={name}></div>
        <h1 className="msg">{errorMsg}</h1>
      </div>
    </>
  );
};

export default WalkingSprite;
